import React from "react";

import { About, Footer, Header, CV, Testimonial, Project_Gallary } from "./container";
import { Navbar } from "./components";
import './App.scss';

const App = () => {
  return (
     <div className="app">
       <Navbar/>
       <Header/>
       <About/>
       <Project_Gallary/>
       <CV/>
       <Testimonial/>
       <Footer/>
    </div>
  );
}

export default App;
